export const SUBTIPE_LABELS: Record<string, string> = {
  iminens: "Abortus Iminens (O20.0)",
  insipiens: "Abortus Insipiens (O03)",
  inkomplit: "Abortus Inkomplit (O03.4)",
  komplit: "Abortus Komplit (O03.9)",
  missed: "Missed Abortion (O02.1)",
  blighted_ovum: "Blighted Ovum (O02.0)",
  septik: "Abortus Septik (O03.0)",
  provokatus_medisinalis: "Abortus Provokatus Medisinalis (O04.x)"
};

export const SUBTIPE_ITEMS = Object.keys(SUBTIPE_LABELS).map(value => ({
  value,
  text: SUBTIPE_LABELS[value]
}));
